import React from 'react';

import {
  VERIFICATION_PRE_SORTIE_CHECKBOX_TEXT,
  VERIFICATION_PRE_SORTIE_TEXT,
} from './constants';

import './VerificationPreSortieCodeML.less';

interface VerificationPreSortieProps {
  children?: React.ReactNode;
}

const VerificationPreSortieCodeML = ({
  children,
}: VerificationPreSortieProps): React.ReactElement => {
  return (
    <>
      <p>{VERIFICATION_PRE_SORTIE_TEXT}</p>
      <div className="verification-pre-sortie-checkbox">{children}</div>
      <p>{VERIFICATION_PRE_SORTIE_CHECKBOX_TEXT}</p>
    </>
  );
};

export default VerificationPreSortieCodeML;
